// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    ASquareAPIURL: 'https://a-square-erp-service.azurewebsites.net/',
    // SiteKey : '6LfVT9AkAAAAAOACH0mKKMpWBhKBod_DrnOgnZt0'

    // ASquareAPIURL: 'https://localhost:7233/',

    // ASquareAPIURL: 'https://a-square-erp-service-a-square-erp-service-prod.azurewebsites.net/',
    WhatsAppURL: 'https://azurevm.asquareerp.com',
    // WhatsAppURL: 'http://localhost:8080',
    aiSensy: {
      apiUrl: 'https://backend.aisensy.com/campaign/t1/api/v2',
      apiKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjZhYjNjMTQyYjMxY2UwZTdmZGFmNzMxYSIsIm5hbWUiOiJUaGUgV2hpdGUgTXVnIiwiYXBwTmFtZSI6IkFpU2Vuc3kiLCJjbGllbnRJZCI6IjZhYjNjMTQyYjMxY2UwZTdmZGFmNzMxNCIsImFjdGl2ZVBsYW4iOiJQUk9fTU9OVEhMWSIsImlhdCI6MTc5MTE5NDgwMn0.A0ibbopRzFVEASyDYLvDhm-xfqixx9aQ8cLRLxTtnRc',
      campaignName: 'Bill2nd',
      source: 'TWM TRIAL',
      templateParams: ['partyName', 'billNo', 'itemsSummary', 'netAmount', 'vchDate'],
      campaignTemplateParams: {
        Bill1st: ['partyName', 'billNo', 'itemsSummary', 'netAmount', 'vchDate'],
        Bill2nd: ['partyName', 'billNo', 'itemsSummary', 'netAmount', 'vchDate'],
        Bill3rd: ['partyName', 'billNo', 'itemsSummary', 'netAmount', 'vchDate'],
      },
    },
    recaptcha: {
      siteKey: '6LfVT9AkAAAAAOACH0mKKMpWBhKBod_DrnOgnZt0',
    },
    CookieEncryptionKey : 'USYdjkcEh6adagRsdPl',
    razorKey : "rzp_live_qq7ep2BPxJGIhL"
};

  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

